import { variant } from 'styled-system';
import { createComponent, createHook } from 'reakit-system';
import { cx, ecss } from '../reexports/emotion';
import { TextHTMLProps, TextOptions, useText } from '../Text/Text';

const size = variant({
  prop: 'size',
  variants: {
    default: {
      fontSize: 'fs-16',
    },
    big: {
      fontSize: 'fs-18',
    },
    small: {
      fontSize: 'fs-14',
    },
  },
});

type ParagraphOptions = TextOptions & { size?: 'small' | 'default' | 'big' };

const useParagraph = createHook<ParagraphOptions, TextHTMLProps>({
  name: 'Paragraph',
  keys: ['size'],
  compose: [useText],
  useProps(options, props) {
    return {
      ...props,
      className: cx(
        // @ts-expect-error
        props.className,
        ecss(size({ size: 'default', ...options }), { label: 'Paragraph' })
      ),
    };
  },
  useOptions(options) {
    return {
      ...options,
      styles: {
        ...options.styles,
        my: '1em',
        lineHeight: 'lh-15',
        '&:first-child': {
          mt: 0,
        },
        '&:last-child': {
          mb: 0,
        },
      },
    };
  },
});

export const Paragraph = createComponent({
  as: 'p',
  useHook: useParagraph,
  memo: true,
});
